import React from 'react'
import { Select, Typography, Button } from 'antd'
import { Formik, Form } from 'formik'

const { Title } = Typography
const { Option } = Select

interface Props {
  onAddNewNode: any
  value: { channel: string }
  onUpdateNode: any
}

const Reachability: React.FC<Props> = ({ onAddNewNode, value, onUpdateNode }) => {
  const defaultValue = { channel: 'web_push' }

  const onSubmit = (values: { channel: string }) => {
    onAddNewNode && onAddNewNode('checkReachability', values)
    onUpdateNode && onUpdateNode(values)
  }

  return (
    <div className="ReachabilityComponent">
      <Formik
        initialValues={value ? value : defaultValue}
        onSubmit={(values) => onSubmit(values)}
        children={({ handleChange, setFieldValue, values }) => (
          <Form>
            <div className="form-item">
              <Title className="field-title" level={5}>
                Reachable on
              </Title>
              <Select value={values.channel} onChange={(value) => setFieldValue('channel', value)}>
                <Option value="email">Email</Option>
                <Option value="web_push">Web push</Option>
                <Option value="ol_app">App push</Option>
                <Option value="sms">SMS</Option>
                <Option value="zalo_group">Zalo group</Option>
                <Option value="zns">ZNS</Option>
                {/* <Option value="kaipass">Kaipass</Option> */}
              </Select>
            </div>

            <div
              className="form-item"
              style={{ display: 'flex', justifyContent: 'flex-end', margin: 0, marginTop: 15 }}
            >
              <Button htmlType="submit" type="primary">
                OK
              </Button>
            </div>
          </Form>
        )}
      />
    </div>
  )
}

export default Reachability
